import { sendPaginateEvent } from '../../utils/event-triggers';
import { get } from '../../utils/object-helpers';
import { getTracking } from './util';

const SEL = {
    menuItem: '.menu-button__item',
    stickySentinel: '.str-header__sticky-sentinel'
};
export default class {
    onMount() {
        this.root = this.getEl('str-pagination');
    }
    onInput(input) {
        return {
            pages: get(input, 'pages', []),
            prevUrl: get(input, 'previousPageIcon.action.URL', ''),
            prevText: get(input, 'previousPageIcon.accessibilityText', ''),
            prevTrack: getTracking(get(input, 'previousPageIcon', {})),
            nextUrl: get(input, 'nextPageIcon.action.URL', ''),
            nextText: get(input, 'nextPageIcon.accessibilityText', ''),
            nextTrack: getTracking(get(input, 'nextPageIcon', {})),
            currText: get(input, 'paginationHeader.text', ''),
            ippLabel: get(input, 'itemsPerPage.label.textSpans.0.text', ''),
            ippCurrOptionText: get(input, 'itemsPerPage.currentOption.text', ''),
            ippCurrOptionA11yText: get(input, 'itemsPerPage.currentOption.accessibilityText', ''),
            ippOptions: get(input, 'itemsPerPage.options', [])
        };
    }
    fetchPage(evt) {
        evt.originalEvent.preventDefault();
        let target = evt.originalEvent.target;
        let href;
        if (target.tagName !== 'A') {
            target = target.closest(SEL.menuItem);
        }
        if (target) {
            href = target.getAttribute('href');
        }
        if (href) {
            this.scrollToTop();
            this.blurLinks();
            sendPaginateEvent({
                url: href,
                successCallback: () => {
                    this.setCurrentPage(href);
                }
            });
        }
    }
    setCurrentPage(href) {
        const pages = get(this.state, 'pages', []);
        for (let i = 0, n = pages.length; i < n; i++) {
            const url = get(pages[i], 'action.URL', '');
            if (url === href) {
                this.state.pages[i].selected = true;
            } else {
                this.state.pages[i].selected = false;
            }
        }
        this.setStateDirty('pages');
    }
    scrollToTop() {
        const stickySentinel = document.querySelector(SEL.stickySentinel);
        if (stickySentinel) {
            const pad = 4;
            const top = stickySentinel.offsetParent.offsetTop + stickySentinel.offsetTop + pad;
            window.scrollTo({
                top,
                left: 0
            });
        }
    }
    blurLinks() {
        if (this.root) {
            const links = this.root.querySelectorAll('A');
            if (links) {
                links.forEach(el => el.blur());
            }
        }
    }
}
